import React, { FC } from 'react';
import HyperLink from '../common/HyperLink';
import { withUserType } from '../withUserType';

const ManageAllNotificationPreference: FC<any> = ({ userType }) => {
	return (
		<div className="mt-4">
			<HyperLink
				text="Manage all notification preferences"
				newTabPath={`/${userType}/settings/notifications`}
			/>
		</div>
	);
};

export default withUserType(ManageAllNotificationPreference);
